import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExternalLink } from 'lucide-react';
import { SourceBox, SourceLink } from '../admin/ui';
import { interestLabel, statusLabel } from './personAdminModel';

// Small pieces the person detail screen, its research and change-set cards and the person panel of
// the program screen all print the same way.

export const formatMoment = (intl, iso) => (iso
  ? intl.formatDate(new Date(iso), { dateStyle: 'medium', timeStyle: 'short' })
  : null);

// A field's value as text: the code lists get their labels, a missing value is empty.
export const valueText = (t, key, value) => {
  if (key === 'professionalStatuses') return (value || []).map((s) => statusLabel(t, s)).join(', ');
  if (key === 'interests') return (value || []).map((i) => interestLabel(t, i)).join(', ');
  return value == null ? '' : String(value);
};

// Where a value came from (D15): the cited pages, or the organizers' own input.
export const Sources = ({ sources }) => (
  <SourceBox>
    <strong><FormattedMessage id="personAdmin.source" defaultMessage="Source" /></strong>
    {sources && sources.length ? sources.map((source, index) => (source.url ? (
      <SourceLink key={index} href={source.url} target="_blank" rel="noreferrer">
        <ExternalLink size={12} />{source.for ? `${source.for}: ` : ''}{source.title || source.url}
      </SourceLink>
    ) : (
      <div key={index}>{source.for ? `${source.for}: ` : ''}{source.title || <FormattedMessage id="personAdmin.source.input" defaultMessage="Organizer input" />}</div>
    ))) : <div><FormattedMessage id="personAdmin.source.none" defaultMessage="No source recorded" /></div>}
  </SourceBox>
);
